import { PaymentQrSettings } from '../admin/payment-qr-settings'
import { BannerManager } from '../admin/banner-manager'
import { SlotsConfig } from '../admin/slots-config'
import { BlockSettings } from '../admin/block-settings'

export function AdminSettingsPage() {
  return (
    <section className="flex flex-col gap-6">
      <div className="rounded-xl border border-border bg-card p-5 shadow-sm">
        <h1 className="text-2xl font-bold text-foreground">Cài đặt</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Trang cài đặt đã được kết nối vào bảng điều khiển.
        </p>
      </div>

      <BlockSettings />
      <SlotsConfig />
      <BannerManager />
      <PaymentQrSettings />
    </section>
  )
}


